@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';

.assist-panel {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: @space-8;
  max-width: 400px;
  padding: @space-16;
  border-radius: 4px;
  border: 1px solid var(--blue-400);
  background-color: var(--blue-200);
  @media @tablet, @mobile, @ultramobile {
    max-width: none;
  }
}

.header-icon {
  height: 20px;
  width: 20px;
  > svg {
    width: inherit;
    height: inherit;
    margin-top: 2px;
    color: hsl(var(--grey-600-base));
  }
}

.content {
  > h3 {
    // override styles from main file
    margin-top: @space-0 !important;
  }
}

.break-line {
  height: 1px;
  background: var(--grey-300);
  margin-top: @space-16;
}
